/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAzureSaasUserManagedOnboarded extends models.StorageConfigurationBaseForAzureSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAzureSaasUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAzureSaasUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAzureSaasUserManagedOnboarded>): StorageConfigurationForAzureSaasUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForAzureSaasUserManagedOnboarded(), model);
        StorageConfigurationForAzureSaasUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAzureSaasUserManagedOnboarded>): StorageConfigurationForAzureSaasUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForAzureSaasUserManagedOnboarded.newInstance(<StorageConfigurationForAzureSaasUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAzureSaasUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForAzureSaasUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAzureSaasUserManagedOnboarded): boolean {
        if (models.StorageConfigurationBaseForAzureSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAzureSaasUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the storage is present.
     */
    account_id: string;

}
